import { TMode } from "interfaces/intarfaces";
import styled, { css } from "styled-components/macro";

export const RoomDetailsWrapper = styled.div`
  display: grid;
  gap: 16px;
  grid-template-areas:
    "typeRoomBox typeRoomBox typeRoomBox typeRoomBox typeRoomBox typeRoomBox"
    "titleRoom titleRoom titleRoom titleRoom titleRoom titleRoom"
    "countryRoom countryRoom countryRoom stateRoom stateRoom stateRoom"
    "postalCode postalCode houseNumber houseNumber addition addition"
    "streetRoom streetRoom streetRoom cityRoom cityRoom cityRoom"
    "photoRooms photoRooms photoRooms photoRooms photoRooms photoRooms";
  grid-template-columns: repeat(6, 1fr);
  @media ${(props) => props.theme.media.tablet} {
    grid-template-areas:
      "typeRoomBox typeRoomBox typeRoomBox typeRoomBox typeRoomBox typeRoomBox"
      "titleRoom titleRoom titleRoom titleRoom titleRoom titleRoom"
      "countryRoom countryRoom countryRoom countryRoom countryRoom countryRoom"
      "stateRoom stateRoom stateRoom stateRoom stateRoom stateRoom"
      "postalCode postalCode postalCode postalCode postalCode postalCode"
      "houseNumber houseNumber houseNumber houseNumber addition addition"
      "streetRoom streetRoom streetRoom cityRoom cityRoom cityRoom"
      "photoRooms photoRooms photoRooms photoRooms photoRooms photoRooms";
  }
  @media ${(props) => props.theme.media.phone} {
    grid-template-areas:
      "typeRoomBox typeRoomBox typeRoomBox typeRoomBox typeRoomBox typeRoomBox"
      "titleRoom titleRoom titleRoom titleRoom titleRoom titleRoom"
      "countryRoom countryRoom countryRoom countryRoom countryRoom countryRoom"
      "stateRoom stateRoom stateRoom stateRoom stateRoom stateRoom"
      "postalCode postalCode postalCode postalCode postalCode postalCode"
      "houseNumber houseNumber houseNumber houseNumber  houseNumber houseNumber"
      "addition addition addition addition addition addition"
      "streetRoom streetRoom streetRoom streetRoom streetRoom streetRoom"
      "cityRoom cityRoom cityRoom cityRoom cityRoom cityRoom"
      "photoRooms photoRooms photoRooms photoRooms photoRooms photoRooms";
  }

  #typeRoomBox {
    grid-area: typeRoomBox;
  }

  #titleRoom {
    grid-area: titleRoom;
  }

  #countryRoom {
    grid-area: countryRoom;
  }

  #stateRoom {
    grid-area: stateRoom;
  }

  #postalCode {
    grid-area: postalCode;
  }

  #houseNumber {
    grid-area: houseNumber;
  }

  #addition {
    grid-area: addition;
  }

  #streetRoom {
    grid-area: streetRoom;
  }

  #cityRoom {
    grid-area: cityRoom;
  }

  #photoRooms {
    grid-area: photoRooms;
  }
`;

export const InfoMessage = styled.span<{ message?: string; left?: string }>`
  position: relative;
  word-break: break-word;
  &:before {
    content: "${(props) => props.message || ""}";
    display: none;
    position: absolute;
    bottom: calc(100% + 4px);
    width: 260px;
    left: ${(props) => props.left || 0};
    text-align: center;
    border-radius: ${(props) => props.theme.sizes.borderRadius};
    color: ${(props) => props.theme.colors.place};
    background-color: ${(props) => props.theme.colors.thirdly};
    padding: 4px 8px;
  }
  &:hover:before {
    display: block;
    font-weight: 100;
  }
`;

export const RadioboxPlace = styled.div<{ active?: boolean; modeView?: TMode }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  ${(props) =>
    props.modeView === "create" &&
    css`
      border-radius: ${(props) => props.theme.sizes.borderRadius};
      border: 1px solid ${(props) => props.theme.colors.border};
    `}

  flex-grow: 1;
  ${(props) =>
    props.active &&
    css`
      background-color: ${(props) => props.theme.colors.activeRadioBox};
      border: 1px solid ${(props) => props.theme.colors.primary};
    `}
`;

export const TypeRoomContainer = styled.div<{ error?: boolean }>`
  display: grid;
  grid-template-areas: "room studio entireHouse";
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  @media (max-width: 530px) {
    grid-template-areas:
      "room"
      "studio"
      "entireHouse";
    grid-template-columns: 1fr;
  }
  ${(props) =>
    props.error &&
    css`
      border: 1px solid red;
      border-radius: 4px;
    `}
`;

export const TypeRoomWrapper = styled.div`
  display: block;
`;
